import { registerView } from "@frui.ts/views";
import type { ViewComponent } from "@frui.ts/views";
import ChargeDetailViewModel from "viewModels/callCenter/search/charges/chargeDetail/chargeDetailViewModel";
import { observer } from "mobx-react-lite";
import Modal from "react-bootstrap/Modal";
import React from "react";
import Tabs from "views/common/tabs";

export const ChargeDetailView: ViewComponent<ChargeDetailViewModel> = observer(({ vm }) => {
  return (
    <Modal show={true} onHide={vm.onClose} dialogClassName="modal-90w modal-100h" centered scrollable>
      <Modal.Header closeButton={true}>
        <Modal.Title>{vm.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Tabs vm={vm} />
      </Modal.Body>
    </Modal>
  );
});

registerView(ChargeDetailView, ChargeDetailViewModel);
